import { compose, createStore, applyMiddleware } from 'redux';
import makeMiddleware from './middleware';
import reducers from './reducers';

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const makeStore = (intialState = { }) => {
  const store = createStore(reducers, intialState, composeEnhancers(applyMiddleware(...makeMiddleware)));

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const nextRootReducer = reducers.default;
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
};

export default makeStore;
